import { useState, SyntheticEvent } from "react";
import ReactDOM from "react-dom";
import IconButton from "@weave-design/icon-button";
import { Unavailable24 } from "@weave-design/icons";
import { ConfirmDialog } from "../../../../confirmDialog/confirmDialog";
import { ProcessingFailure } from "../../../../processing-failure/processingFailure";
import { ProcessingPane } from "../../../../processing-pane/processingPane";
import { rootElement } from "../../../../shared";
import eventBus from "../../../eventBus/eventDispatcher";
import repo from "../../../../../Repository";

type Props = {
    id: string;
    name: string;
};

export const RemoveLinkedModel = ({ id, name }: Props) => {
    const [inProgress, setInProgress] = useState(false);
    const [confirmationDialogOpened, setConfirmationDialogOpened] = useState(false);
    const [failure, setFailure] = useState("");

    const openConfirmationDialog = (e: SyntheticEvent) => {
        e.stopPropagation();
        setConfirmationDialogOpened(true);
    };

    const removeLinkedModel = async () => {
        setConfirmationDialogOpened(false);
        setInProgress(true);

        const result = await repo.removeLinkedModel(id);

        setInProgress(false);

        if (result.isSuccess) {
            eventBus.dispatchEvent({ type: "Dextall.LinkedModels.ModelRemoved", payload: id });
        } else {
            setFailure(result.message);
        }
    };

    return (
        <>
            <IconButton
                icon={
                    <div style={{ width: 24, height: 24 }}>
                        <Unavailable24 className="errorIcon" />
                    </div>
                }
                title="Remove linked model"
                onClick={openConfirmationDialog}
            />

            {inProgress &&
                ReactDOM.createPortal(
                    <ProcessingPane isVisible message="Removing linked model..." title="Linked model" />,
                    rootElement,
                )}

            {confirmationDialogOpened &&
                ReactDOM.createPortal(
                    <ConfirmDialog
                        isOpened
                        title="Linked model"
                        confirmButtonTitle="Delete"
                        deleteButtonClassName="redButton"
                        onCancel={() => setConfirmationDialogOpened(false)}
                        onConfirm={removeLinkedModel}
                    >
                        Are you sure you want to delete linked model <b>{name}</b>?
                    </ConfirmDialog>,
                    rootElement,
                )}

            {failure &&
                ReactDOM.createPortal(
                    <ProcessingFailure
                        isVisible
                        title="Linked model"
                        message={failure}
                        closeProcessingErrorDialog={() => setFailure("")}
                    />,
                    rootElement,
                )}
        </>
    );
};
